import React from 'react'

interface HtGoldMarqueeProps {
  text: string
}

function MarqueeIcon() {
  return (
    <svg className="htg-marquee__icon" viewBox="0 0 24 24" width="15" height="15" aria-hidden>
      <path
        fill="currentColor"
        d="M18 11c0-5-4-7-8-7v14c4 0 8-2 8-7zm-6 5V8c2.5 0 4 1.2 4 4s-1.5 4-4 4zM4 9v6h3l4 4V5L7 9H4z"
      />
    </svg>
  )
}

const HtGoldMarquee: React.FC<HtGoldMarqueeProps> = ({ text }) => {
  const display = text.trim() || 'ยินดีต้อนรับสู่เว็บหวยออนไลน์ มั่นคง จ่ายจริงทุกโพย'
  if (!display) return null

  return (
    <div className="htg-marquee htg-marquee--in" role="region" aria-label="ประกาศ">
      <span className="htg-marquee__badge" aria-hidden>
        <span className="htg-marquee__pulse" />
        <span className="htg-marquee__pulse htg-marquee__pulse--delay" />
        <MarqueeIcon />
      </span>
      <div className="htg-marquee__track-wrap">
        <div className="htg-marquee__track">
          <span className="htg-marquee__item">{display}</span>
          <span className="htg-marquee__item" aria-hidden>
            {display}
          </span>
        </div>
      </div>
    </div>
  )
}

export default HtGoldMarquee
